import request from '@/libs/request'

export function articleList (data) {
  return request({
    url: `article/list`,
    method: 'get',
    params: data
  })
}

// 公告详情
export function articleInfo (data) {
  return request({
    url: `article/info`,
    method: 'get',
    params: data
  })
}

// 添加公告
export function eidtArticle (data) {
  return request({
    url: `article/edit`,
    method: 'post',
    data: data
  })
}



// 删除公告
export function delNew (id) {
  let data = { article_id: id }
  return request({
    url: `article/delete`,
    method: 'post',
    data: data
  })
}

//
export function homesaty_getalllist () {
  return request({
    url: `homestay/getalllist`,
    method: 'get',
  })
}

export function changeSort (params) {
  return request({
    url: `article/changeSort`,
    method: 'get',
    params
  })
}
// 启用禁用
export function changeStatus (id) {
  return request({
    url: `article/changeStatus/${id}`,
    method: 'post'
  })
}
export function getIndexCate (params) {
  return request({
    url: `article/getIndexCate`,
    method: 'get',
    params
  })
}
